import "src/decidim/proposals/utils";
import "src/decidim/proposals/add_proposal";
import "src/decidim/proposals/choose_proposals";
import "src/decidim/proposals/exit_handler";
require.context("../images", true);
require.context("../documents", true);
import "stylesheets/decidim/proposals/proposals.scss";
